import React from "react";
import { Row, Col } from "react-bootstrap";
import Welcome from "../../mycomp/Dashboard/eCommerce/Welcome";
import TotalSales from "../../mycomp/Dashboard/eCommerce/TotalSales";
import LeadsBySource from "../../mycomp/Dashboard/CRM/LeadsBySource";
import ProjectsOverview from "../../mycomp/Dashboard/ProjectManagement/ProjectsOverview";
import BasicTimeLineChart from "../../mycomp/Charts/MoreCharts/BasicTimelineChart";
import RecentEarnings from '../../mycomp/Dashboard/Sales/RecentEarnings';
import PopularRooms from "../../mycomp/Dashboard/Hotel/PopularRooms";
import AppUsageList from "../../mycomp/Tables/BasicTable/AppUsageList";
import { useDashboardData } from "../../hooks/useDashboardData";
import { AuthContext } from "../../context/AuthContext";
import {useContext } from "react";



const MyDashboard = () => {
  const { user } = useContext(AuthContext);
  const {timelineData, screenshots, workspaces, projects} = useDashboardData(user.id);

  // Wait until workspaces and projects are loaded
  const totalWorkspaces = workspaces?.length || 0;
  const totalProjects = projects?.length || 0;

  return (
    <>
      <Row>
        <Col xs={12} lg={6}>
          <Welcome
            workspaceCount={totalWorkspaces}
            projectCount={totalProjects}
          />
          <ProjectsOverview />
          
        </Col>

        <Col xs={12} lg={6}>
            <TotalSales />
        </Col>
        
      </Row>

      <Row>
        <Col xs={12} lg={8} xl={8}>
          <AppUsageList />
        </Col>
        
        <Col xs={12} lg={4} xl={4}>
          <LeadsBySource />
        </Col>
      </Row>


      <Row>
        <Col xs={12} lg={12} xl={12} xxl={12}>
          <BasicTimeLineChart timelineData={timelineData} />
        </Col>
      </Row>

      <Row>
          <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
            <RecentEarnings />
          </Col>
      </Row>

      <Row>
        <Col xs={12} lg={12} xl={12} xxl={12}>
          <PopularRooms screenshotsData={screenshots} /> 
        </Col>

      </Row>
    </>
  );
};


export default MyDashboard;
